/* eslint no-param-reassign: 0 */

const initialState = {};

const gettersDef = {};

const actions = {
  fetchSurveys({ dispatch, rootGetters }, { params = {} } = {}) {
    const mergedParams = {
      ...params,
      company: rootGetters["auth/activeCompany"].id
    };
    return dispatch(
      "api/sendRequest",
      { method: "get", url: "/insight/surveys/", params: mergedParams },
      { root: true }
    );
  },
  createSurvey({ dispatch }, { data }) {
    return dispatch(
      "api/sendRequest",
      { method: "post", url: "/insight/surveys/", data },
      { root: true }
    );
  },
  duplicateSurvey({ dispatch }, { id }) {
    return dispatch(
      "api/sendRequest",
      { method: "post", url: `/insight/surveys/${id}/duplicate/` },
      { root: true }
    );
  },
  deleteSurvey({ dispatch }, { id }) {
    return dispatch(
      "api/sendRequest",
      { method: "delete", url: `/insight/surveys/${id}` },
      { root: true }
    );
  },
  fetchSurvey({ dispatch }, { id }) {
    return dispatch(
      "api/sendRequest",
      { method: "get", url: `/insight/surveys/${id}/` },
      { root: true }
    );
  },
  updateSurvey({ dispatch }, { data }) {
    return dispatch(
      "api/sendRequest",
      { method: "put", url: `/insight/surveys/${data.id}/`, data },
      { root: true }
    );
  },
  patchSurvey({ dispatch }, { data }) {
    return dispatch(
      "api/sendRequest",
      { method: "patch", url: `/insight/surveys/${data.id}/`, data },
      { root: true }
    );
  },
  fetchOverallReport({ dispatch }, { id, params = {} } = {}) {
    return dispatch(
      "api/sendRequest",
      { method: "get", url: `/insight/reports/surveys/${id}/`, params },
      { root: true }
    );
  },
  fetchAnswersReport({ dispatch }, { id, params = {} } = {}) {
    return dispatch(
      "api/sendRequest",
      { method: "get", url: `/insight/reports/surveys/${id}/answers/`, params },
      { root: true }
    );
  },
  fetchAnswers({ dispatch }, { params = {} } = {}) {
    return dispatch(
      "api/sendRequest",
      { method: "get", url: "/insight/survey-answers/", params },
      { root: true }
    );
  },
  fetchPunchCards({ dispatch }, { id, params = {} } = {}) {
    return dispatch(
      "api/sendRequest",
      {
        method: "get",
        url: `/insight/reports/surveys/${id}/punchcards/`,
        params
      },
      { root: true }
    );
  }
};

const mutations = {};

export default {
  namespaced: true,
  state: initialState,
  getters: gettersDef,
  actions,
  mutations
};
